export default __webpack_public_path__ + "static/media/fetch_pals_techStacks.3034c6eb.jpg";